module.exports = __webpack_public_path__ + "img/focus-group.56598b9f.png";